import { type UploaderOptions, type UploadProgress } from '@meitu/upload';

export type FileType = 'image/png' | 'image/jpg' | 'image/jpeg' | 'image/heic' | 'image/webp' | 'image/gif';

export interface IObsOptions extends Partial<Pick<UploaderOptions, 'accessToken' | 'debug'>> {
    /**
     * 是否对上传接口参数进行加签
     *
     * @default false
     */
    signature?: boolean;
    customMaatType?: string; // 覆盖全局的type
    customSuffix?: string; // 自定义后缀
    /** 指定上传目标 file_key（跨端传图等场景） */
    fileKey?: string;
    partSize?: number; //分片大小 默认4mb
    maxConcurrent?: number; //分片并发数量
    onUploadProgress?: (result: UploadProgress) => void; //上传进度
    maxRetries?: number; // 失败重试次数，默认3次
}

export interface ILimitConfig {
    autoResizeWH?: number; // 自动压缩到目标尺寸
    maxWH?: number; // 最大宽高
    minWH?: number; // 最小宽高
    maxSize?: number; // 最大体积
    accepts?: FileType[]; // 支持格式
}

// TODO 各个流程的hook
export interface IImageUploadOptions extends IObsOptions {
    limitConfig?: ILimitConfig;
    noUploadObs?: boolean; // 不自动上传到obs
    autoConvertWebp?: boolean; // webp自动转格式
    autoConvertGif?: boolean; // gif自动转格式
    convertType?: 'image/jpeg' | 'image/png'; // heic、webp的转换目标格式
    extraOutput?: {
        // 额外原图获取，要获取本地图片返回需要获取这个值
        // 默认ImageObject
        type?: 'ImageObject' | 'ImageURL';
        maxWH?: number;
    };
}

// 上传结果
export interface IImageUploadResult {
    url: string;
    width: number;
    height: number;
    // 处理过的图片，走云端处理的获取不到
    processedFile?: File;
    extraOutputImg?: HTMLImageElement | string;
}

/**
 * 0 成功
 * 1 格式不支持
 * 2 体积超限
 * 3 尺寸超限
 * 4 尺寸过小
 * 5 格式转换失败
 * 6 尺寸裁剪失败
 */
export enum UploadStatusCode {
    Success = 0,
    TypeError = 1,
    FileTooLarge = 2,
    ImageTooLarge = 3,
    ImageTooSmall = 4,
    ConvertError = 5,
    ResizeError = 6,
}
